import { Form, Table } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getToilData, getAllOvertime } from "../../redux/rtk/features/overtime/overtimeSlice";
import getUserFromToken from "../../utils/getUserFromToken";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

function GetToil({ validityId, userId }) {
    const dispatch = useDispatch();
    const { toilData, loading } = useSelector((state) => state.overtime);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [form] = Form.useForm();
    const loggedInUserId = getUserFromToken();
    
    // Use provided userId if explicitly set (after user selects from dropdown),
    // otherwise default to logged-in user ID
    let filterUserId = null;
    if (userId !== undefined && userId !== null) {
        // User explicitly selected from dropdown - filter by that user
        filterUserId = parseInt(userId);
    } else if (loggedInUserId) {
        // Default: filter by logged-in user
        filterUserId = parseInt(loggedInUserId);
    }
    // If userId is explicitly null (user cleared selection), filterUserId remains null
    // and we'll show all data as fallback

    console.log("GetToil - toilData:", toilData);
    console.log("GetToil - filterUserId:", filterUserId);
    console.log("GetToil - userId prop:", userId);
    console.log("GetToil - loggedInUserId:", loggedInUserId);
    console.log("GetToil - userId type:", typeof userId);

    useEffect(() => {
        dispatch(getToilData());
    }, [dispatch]);

    // Refresh data when userId changes
    useEffect(() => {
        dispatch(getToilData());
    }, [userId, dispatch]);

    const formatOvertimeLength = (length) => {
        const hours = Math.floor(length);
        const minutes = Math.round((length - hours) * 60);
        return `${hours}h ${minutes}m`;
    };

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            title: "Date",
            key: "date",
            render: (_, record) => {
                // Show toilLoggedDate if it exists, otherwise show toilTakenDate
                const dateToShow = record.toilLoggedDate || record.toilTakenDate;
                return dateToShow ? dayjs(dateToShow).utc().format("DD-MM-YYYY, HH:mm A") : "N/A";
            },
        },
        {
            title: "Added Toil",
            key: "addedToil",
            render: (_, record) => {
                // Show toilLogged value
                return record.toilLogged ? formatOvertimeLength(record.toilLogged) : "N/A";
            },
        },
        {
            title: "Toil Taken",
            key: "toilTaken",
            render: (_, record) => {
                // Show toilTaken value
                return record.toilTaken ? formatOvertimeLength(record.toilTaken) : "N/A";
            },
        },
        {
            title: "Toil Balance",
            dataIndex: "toilBalance",
            key: "toilBalance",
            render: (toilBalance) => formatOvertimeLength(toilBalance),
        },
        
    ];

    const handleAction = (record) => {
        setSelectedRecord(record);
        form.setFieldsValue({
            user: `${record.user.firstName} ${record.user.lastName}`,
            overtimeHours: record.overtimeLength,
            overtimeStatus: record.status ? "Approved" : "Pending",
        });
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
        form.resetFields();
    };

    const handleModalSubmit = async () => {
        try {
            const values = await form.validateFields();
            // Submit logic (e.g., update data via an API call)
            toast.success("Overtime data updated successfully!");
            setIsModalVisible(false);
            form.resetFields();
        } catch (info) {
            console.error("Validation Failed:", info);
        }
    };

    // Filter and map data based on userId
    // userId === null means user explicitly cleared the selection (want to see all)
    // userId === undefined means no selection has been made yet (use logged-in user)
    let filteredData = [];
    
    const isExplicitClear = userId === null;
    const isDefaultCase = userId === undefined || 
                          (userId !== null && loggedInUserId && parseInt(userId) === parseInt(loggedInUserId));
    
    if (isExplicitClear) {
        // User explicitly cleared selection - show all data
        filteredData = toilData?.data || [];
        console.log("GetToil - User cleared selection, showing all data");
    } else if (filterUserId !== null && filterUserId !== undefined && !isNaN(filterUserId)) {
        // Filter by the target userId
        filteredData = (toilData?.data || []).filter((item) => {
            const itemUserId = typeof item.userId === 'number' ? item.userId : parseInt(item.userId);
            return itemUserId === filterUserId;
        });
        
        // If no data found for the target user AND it's the default case (logged-in user),
        // show all data instead
        if (filteredData.length === 0 && isDefaultCase) {
            filteredData = toilData?.data || [];
            console.log("GetToil - No data for logged-in user, showing all data");
        }
    } else {
        // No valid filter, show all data
        filteredData = toilData?.data || [];
        console.log("GetToil - No valid filterUserId, showing all data");
    }

    console.log("GetToil - filteredData length:", filteredData.length);
    console.log("GetToil - filteredData:", filteredData);
    console.log("GetToil - userId prop value:", userId);
    console.log("GetToil - Total toilData.data length:", (toilData?.data || []).length);

    // Access toilData.data (the actual array) instead of toilData directly
    const dataSource = filteredData.map((item, index) => ({
        ...item,
        serial: index + 1,
    }));

    return (
        <div>
            {/* Display a loading message or no data available message */}
            {loading && <div>Loading...</div>}
            {!loading && (!toilData || filteredData.length === 0) && <div></div>}
            
            <Table
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                rowKey="id"
            />
            
            
        </div>
    );
}

export default GetToil;
